var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomizeTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 7C6.5 6.44772 6.94772 6 7.5 6H14.5C15.0523 6 15.5 6.44772 15.5 7V14C15.5 14.5523 15.0523 15 14.5 15H7.5C6.94772 15 6.5 14.5523 6.5 14V7ZM8.5 13V8H13.5V13H8.5Z",
    fill: "#0D2549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 18C6.5 17.4477 6.94772 17 7.5 17H14.5C15.0523 17 15.5 17.4477 15.5 18V25C15.5 25.5523 15.0523 26 14.5 26H7.5C6.94772 26 6.5 25.5523 6.5 25V18ZM8.5 24V19H13.5V24H8.5Z",
    fill: "#0D2549"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6C19.5147 6 17.5 8.01472 17.5 10.5C17.5 12.9853 19.5147 15 22 15C24.4853 15 26.5 12.9853 26.5 10.5C26.5 8.01472 24.4853 6 22 6ZM19.5 10.5C19.5 11.8807 20.6193 13 22 13C23.3807 13 24.5 11.8807 24.5 10.5C24.5 9.11929 23.3807 8 22 8C20.6193 8 19.5 9.11929 19.5 10.5Z",
    fill: "#0D2549"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 18C17.5 17.4477 17.9477 17 18.5 17H25.5C26.0523 17 26.5 17.4477 26.5 18V25C26.5 25.5523 26.0523 26 25.5 26H18.5C17.9477 26 17.5 25.5523 17.5 25V18ZM19.5 24V19H24.5V24H19.5Z",
    fill: "#0D2549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeTarget);
export default __webpack_public_path__ + "static/media/customizeTarget.4558cde6880ff10c6f23aca85784b15f.svg";
export { ForwardRef as ReactComponent };